import React, { useState } from 'react';
import { Collapse } from 'reactstrap';

function ViewMyReferences(props) {
    const [collapse, setCollapse] = useState(false);
    const toggle = () => setCollapse(!collapse);
    return (
        <div className="mg-t-20" >
        <div className="card" >
            <div className="card-header">
                <div className="card-header-left">
                    <h5>References</h5>
                </div>
                <div className="card-header-right">
                    <ul className="row" >                        
                          
                        <li><i className={collapse ? "fa fa-chevron-down" : "fa fa-chevron-up"} onClick={toggle}></i></li>                                 
                        
                    </ul>
                </div>
            </div>
            <Collapse isOpen={!collapse}>            
            <hr className="mg-l-20" ></hr>
            <div className="card-block">
                <div className="v-align mg-b-15">
                    <div className="wd-pct-20 mg-r-15 b-r-border" >
                    <div >
                        <div>Manjula Sharada</div>
                        <div>manjula.sharada@gmail.com</div>
                        <div>+91 9922456781</div>
                    </div>
                        
                    </div>
                    <div >
                    <div className="card-list-header">Manager</div>
                        <div className="card-list-subheader">GE Capital International Services</div>           
                    </div>
                </div>                
                <hr className="mg-r-0" ></hr> 
                <div className="v-align mg-b-15">
                    <div className="wd-pct-20 mg-r-15 b-r-border" >
                    <div >
                        <div>Anjan Mukherjee</div>
                        <div>anjan.mukherjee@jnu.com</div>
                        <div>+91 9922456781</div>
                    </div> 
                        
                    </div> 
                    <div >
                    <div className="card-list-header">Professor</div>
                        <div className="card-list-subheader">Jawaharlal Nehru University</div>   
                    </div>                   
                </div>  
                       
            </div>
            </Collapse>
    </div>
    </div>
        
    );
  }

export default ViewMyReferences